"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditTaskData = void 0;
var _react = require("react");
var _hooks = require("../../../../../hooks");
var _main = require("../../../../../main");
var _Button = require("../../../../../UI/Button");
var _Icon = require("../../../../../UI/Icon");
var _Menu = require("../../../../../UI/Menu");
var _http = require("../../../../../utilities/http");
var _urls = require("../../../../../utilities/urls");
var _useIframe2 = require("../../../hooks/useIframe");
var _TaskManager = require("../../../TaskManager.provider");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var EditTaskData = function EditTaskData(props) {
  var itemID = props.itemID,
    taskID = props.taskID,
    itemLanguage = props.itemLanguage,
    kotarParams = props.kotarParams,
    minDate = props.minDate,
    maxDate = props.maxDate,
    isLearningActivity = props.isLearningActivity;
  var _useContext = (0, _react.useContext)(_TaskManager.TaskManagerContext),
    isMobileView = _useContext.isMobileView,
    task = _useContext.task,
    setTask = _useContext.setTask,
    unitData = _useContext.unitData,
    setIsCloneItem = _useContext.setIsCloneItem,
    setIsCloneItemError = _useContext.setIsCloneItemError,
    setEditTaskDataName = _useContext.setEditTaskDataName,
    setEditTaskDataGuideLines = _useContext.setEditTaskDataGuideLines,
    setIsEditTaskDataChanged = _useContext.setIsEditTaskDataChanged,
    setIsEditTaskDataOpened = _useContext.setIsEditTaskDataOpened,
    getLabel = _useContext.getLabel;
  var _useSessionData = (0, _hooks.useSessionData)(),
    isSessionDataReady = _useSessionData.isSessionDataReady,
    userId = _useSessionData.userId;
  var _useIframe = (0, _useIframe2.useIframe)(itemID, itemLanguage, taskID, kotarParams, minDate, maxDate),
    setIframeData = _useIframe.setIframeData;
  var editItem = function editItem() {
    if (isSessionDataReady && userId && unitData && task !== null && task !== void 0 && task.item) {
      var startStudio = function startStudio(id, lang) {
        setIframeData({
          src: unitData && unitData.taskFormUrls && unitData.taskFormUrls.studioUrl && unitData.taskFormUrls.studioUrl ? unitData.taskFormUrls.studioUrl.replace('http:', '').replace('{0}', id || '').replace('{1}', lang || '').replace('{2}', 'studioLO') : ''
        });
      };
      var toCopy = true;
      if (!task.item.isCet && task.item.ownerId === userId && !task.item.hasStarted) {
        toCopy = false;
      }
      if (toCopy) {
        setIsCloneItem(true);
        var id = (task === null || task === void 0 ? void 0 : task.item) && task.item.id || itemID;
        var lang = (task === null || task === void 0 ? void 0 : task.item) && task.item.cetLanguage || itemLanguage;
        _http.http.get("".concat(_urls.ofakimApiUrl, "/lmscp/cloneItemToPersonalFolder?itemID=").concat(id, "&cetLanguage=").concat(lang)).then(function (_id) {
          if (_id && typeof _id === 'string') {
            setTask(_objectSpread(_objectSpread({}, task), {}, {
              item: _objectSpread(_objectSpread({}, task.item), {}, {
                id: _id,
                isCet: false
              })
            }));
            setIsCloneItemError(false);
            startStudio(_id, lang);
          } else {
            setIsCloneItemError(true);
          }
          setIsCloneItem(false);
        }).catch(function (error) {
          setIsCloneItemError(true);
          setIsCloneItem(false);
        });
      } else {
        startStudio(task.item.id, task.item.cetLanguage);
      }
    }
  };
  var openEditTaskDataForm = function openEditTaskDataForm() {
    setEditTaskDataName(task.name);
    setEditTaskDataGuideLines(task.guideLines);
    // if (taskApiTinymceRef && taskApiTinymceRef.current) {
    //   taskApiTinymceRef.current.setContent(task.guideLines);
    // }
    setIsEditTaskDataChanged(false);
    setIsEditTaskDataOpened(true);
  };
  var options = [{
    value: 'edit-data',
    label: getLabel('title_edit_Tooltip'),
    onClick: openEditTaskDataForm,
    isDisabled: !task || task.hasStarted || task.cannotModifyMembers || task.isReadOnly
  }, {
    value: 'edit-item',
    label: getLabel('open_studio_btn'),
    onClick: editItem,
    isDisabled: !task || task.hasStarted || task.cannotModifyMembers || task.isReadOnly
  }];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: isMobileView || isLearningActivity ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      view: "contained",
      shape: "round",
      size: "medium",
      onClick: openEditTaskDataForm,
      category: isMobileView ? 'assignActivity' : undefined,
      label: isMobileView ? 'editActivity' : undefined,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        name: "Pen",
        width: "24",
        height: "24"
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Tooltip, {
      position: "top",
      anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
        options: options,
        isBoxCenteredToAnchor: true,
        btnProps: {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            name: "Pen",
            width: "16",
            height: "16"
          }),
          view: 'contained',
          shape: 'round',
          size: 'small'
        }
      }),
      children: getLabel('open_studio_btn')
    })
  });
};
exports.EditTaskData = EditTaskData;